<div class="row" style="width: 100%; margin: 10px 0px">
    <div class="col-md-2 mt-4 mb-4">
        <mat-label class="font-style-title">Add logo</mat-label>

        <div class="profile_label">
            <div class="project-logo-wrapper">
                <span
                    *ngIf="!orgLogo && !addOrganizationFrom?.get('organization_name').value"
                    class="mdi mdi-image-search profile-image-instance"
                    id="profile_image_instance"
                    (click)="imageUpload.click()"
                ></span>
                <img
                    *ngIf="orgLogo"
                    [src]="orgLogo"
                    alt=""
                    class="profile_image_organization"
                    id="profile_image_organization"
                    #profile_image_organization
                    (click)="imageUpload.click()"
                />
                <div class="avatar-container">
                    <div *ngIf="!orgLogo && addOrganizationFrom?.get('organization_name').value">
                        <!-- <ngx-avatars [name]="addOrganizationFrom.value.organization_name" initialsSize="3" size="150"
                            bgColor="#ffcc01" fgColor="#010101"></ngx-avatars> -->
                        <div
                            class="custom-avatar"
                            [ngStyle]="{
                                width: '150px',
                                height: '150px',
                                backgroundColor: '#ffcc01',
                                color: '#010101',
                                fontSize: '50px',
                            }"
                        >
                            {{ getInitials(addOrganizationFrom.value?.organization_name) }}
                        </div>
                    </div>
                </div>
                <div class="icon-wrapper">
                    <div class="edit-icon" (click)="imageUpload.click()">
                        <mat-icon>edit</mat-icon>
                    </div>
                    <div class="delete-icon" *ngIf="orgLogo">
                        <mat-icon (click)="deleteSelectedImage()">delete</mat-icon>
                    </div>
                </div>
            </div>
            <input
                id="fileInput"
                accept="image/*"
                (click)="imageUpload.value = null"
                type="file"
                (change)="onSelectFile($event)"
                #imageUpload
                style="display: none"
            />
        </div>
    </div>
    <div class="col-md-10 mt-4 mb-4">
        <form [formGroup]="addOrganizationFrom" *ngIf="addOrganizationFrom">
            <mat-label class="font-style form-section-heading"><b>Organization Details</b></mat-label>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Organization Name</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter organization name here"
                            name="organization_name"
                            (input)="detectValueChanges($event)"
                            formControlName="organization_name"
                            (keypress)="omitSpecialChar($event)"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">SFDC Customer Number</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter SFDC customer number here"
                            name="sfdc_number"
                            (input)="detectValueChanges($event)"
                            formControlName="sfdc_customer_number"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Number of Instances</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="number"
                            matInput
                            placeholder="Enter number of instances here"
                            name="number_of_instance"
                            (input)="detectValueChanges($event)"
                            formControlName="number_of_instances"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Number of Project Assured Licenses</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="number"
                            matInput
                            placeholder="Enter number of project assured licenses here"
                            name="number_of_iDMS_licenses"
                            (input)="detectValueChanges($event)"
                            formControlName="number_of_iDMS_licenses"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Number of Joint Assured Licenses</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="number"
                            matInput
                            placeholder="Enter number of joint assured licenses here"
                            name="number_of_ICE_licenses"
                            (input)="detectValueChanges($event)"
                            formControlName="number_of_ICE_licenses"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Contract Name</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contract holder name here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contract_holder_name"
                            (keypress)="omitSpecialChar($event)"
                            autocomplete="off"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Start Date</mat-label>

                    <dx-date-box
                        class="dx-date-custom-wrapper"
                        [value]="now"
                        formControlName="start_date"
                        displayFormat="dd-MMM-yyyy"
                        [min]="minDateStart"
                        [inputAttr]="{ 'aria-label': 'Choose Start Date' }"
                        [disabled]="isEditEnabled === false"
                        (input)="detectValueChanges($event)"
                        blockDateTyping
                    >
                    </dx-date-box>
                    <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">End Date</mat-label>

                    <dx-date-box
                        class="dx-date-custom-wrapper"
                        [value]="now"
                        formControlName="end_date"
                        displayFormat="dd-MMM-yyyy"
                        [min]="minDateStart"
                        [inputAttr]="{ 'aria-label': 'Choose End Date' }"
                        [disabled]="isEditEnabled === false"
                        (input)="detectValueChanges($event)"
                        blockDateTyping
                    >
                    </dx-date-box>
                    <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-3">
                    <mat-label class="font-style">Description</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <textarea
                            type="text"
                            rows="1"
                            matInput
                            placeholder="Enter Description"
                            name="description"
                            (input)="detectValueChanges($event)"
                            formControlName="organization_description"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        ></textarea>
                    </mat-form-field>
                </div>
                <!-- <mat-checkbox color="primary" (change)="azureADChecked($event)" formControlName="federated_organization">
          Is Federated Organization?
        </mat-checkbox> -->
                <!-- <div class="idms-license-toggle">
          <mat-label class="font-style">Is Federated Organization? </mat-label>
          <mat-slide-toggle formControlName="federated_organization"></mat-slide-toggle>
        </div> -->
            </div>

            <br />
            <mat-checkbox class="checkbox-wrap" color="primary" (change)="azureADChecked($event)" formControlName="federated_organization">
                <!-- [disabled]="isFederatedCheckbox || isEditEnabled === false" -->
                Is Federated Organization? </mat-checkbox
            ><br /><br />
            <mat-label class="font-style form-section-heading"><b>Contract Holder Details</b></mat-label>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">First Name</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            [matAutocomplete]="auto1"
                            #inputAutoComplete
                            placeholder="Enter contact holder first name here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_first_name"
                            (keypress)="omitSpecialChar($event)"
                            autocomplete="off"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                        <mat-autocomplete #auto1="matAutocomplete" [panelClass]="'autocomplete-panel'" [displayWith]="displayFn">
                            <mat-option
                                class="view-content option-list"
                                *ngFor="let option of profileContactFirstName"
                                [value]="option.firstName"
                                (onSelectionChange)="onEnter($event, 'firstName')"
                            >
                                <span>First Name: {{ option.firstName }}</span
                                ><br />
                                <span>Last Name: {{ option.lastName }}</span
                                ><br />
                                <span>Email: {{ option.email }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Last Name</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            [matAutocomplete]="auto2"
                            placeholder="Enter contact holder last name here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_last_name"
                            (keypress)="omitSpecialChar($event)"
                            autocomplete="off"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                        <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                            <mat-option
                                class="view-content"
                                *ngFor="let option of profileContactLastName"
                                [value]="option.lastName"
                                (onSelectionChange)="onEnter($event, 'lastName')"
                            >
                                <!-- {{option}} -->
                                <span>First Name: {{ option.firstName }}</span
                                ><br />
                                <span>Last Name: {{ option.lastName }}</span
                                ><br />
                                <span>Email: {{ option.email }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Job Title</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder job title here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_job_title"
                            (keypress)="omitSpecialChar($event)"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Telephone</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder telephone here"
                            pattern="[0-9\s]*"
                            (input)="detectValueChanges($event)"
                            name="asset_icon"
                            formControlName="contact_holder_telephone"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Email</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="email"
                            matInput
                            [matAutocomplete]="auto3"
                            #input_email
                            placeholder="Enter contact holder email here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_email"
                            autocomplete="off"
                            email="true"
                            [readonly]="isEditEnabled === false"
                        />
                        <mat-autocomplete #auto3="matAutocomplete" [displayWith]="displayFn">
                            <mat-option
                                class="view-content"
                                *ngFor="let option of profileContactEmail; let i = index"
                                [value]="option.email"
                                (onSelectionChange)="onEnter($event, 'email')"
                            >
                                <!-- {{option}} -->
                                <span>First Name: {{ option.firstName }}</span
                                ><br />
                                <span>Last Name: {{ option.lastName }}</span
                                ><br />
                                <span>Email: {{ option.email }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>

            <mat-label class="font-style form-section-heading"><b>Contract Holder Address</b></mat-label>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Address Line 1</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder address here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_address_line1"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Address Line 2</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder address here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_address_line2"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">City</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder city here"
                            name="asset_icon"
                            formControlName="contact_holder_city"
                            (input)="detectValueChanges($event)"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">State</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder state here"
                            name="asset_icon"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_state"
                            [readonly]="isEditEnabled === false"
                            (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col-md-3">
                    <mat-label class="font-style">Country</mat-label>
                    <mat-select
                        class="dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        name="Country"
                        placeholder="Select Country"
                        formControlName="contact_holder_country"
                        (change)="detectValueChanges($event)"
                        [disabled]="isEditEnabled === false"
                    >
                        <ng-container *transloco="let t; read: 'ORG_DETAILS.COUNTRY'">
                            <mat-option class="option-list" value="{{ c }}" *ngFor="let c of country; let i = index">
                                {{ t(c) }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </div>
                <div class="col-md-3">
                    <mat-label class="font-style">Zipcode</mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input
                            type="text"
                            matInput
                            placeholder="Enter contact holder zipcode here"
                            name="asset_icon"
                            pattern="[a-zA-z0-9][a-zA-z0-9\- ]*[a-zA-z0-9]"
                            (input)="detectValueChanges($event)"
                            formControlName="contact_holder_zipcode"
                            [readonly]="isEditEnabled === false"
                        />
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</div>
